import React from "react";

import InstallationTable from "./InstallationTable";


import {

    FaBrain,
    FaChartLine,
    FaBell,
    FaDatabase,
    FaSyncAlt

} from "react-icons/fa";



class TradingIntelligenceCard extends React.Component {



    render(){

        //console.log(
        //"Trading Intelligence installations:",
        //this.props.installations
    //);




        return (



            <div className="idms-card intelligence-card">





                <div className="card-header">



                    <div>


                        <h2 className="card-title">

                            Trading Intelligence

                        </h2>



                        <p className="card-subtitle">

                            AI-powered market analysis and signal monitoring

                        </p>



                    </div>



                    <FaBrain

                        className="header-icon"

                    />



                </div>







                <div className="intelligence-grid">





                    <div className="intelligence-item">


                        <FaBrain />


                        <div>


                            <span>

                                AI Engine

                            </span>



                            <strong className="online-text">

                                Active

                            </strong>



                        </div>


                    </div>








                    <div className="intelligence-item">


                        <FaChartLine />


                        <div>


                            <span>

                                Signal Engine

                            </span>



                            <strong>

                                Monitoring

                            </strong>



                        </div>


                    </div>








                    <div className="intelligence-item">


                        <FaBell />


                        <div>


                            <span>

                                Alerts

                            </span>



                            <strong>

                                Enabled

                            </strong>



                        </div>


                    </div>








                    <div className="intelligence-item">


                        <FaDatabase />


                        <div>


                            <span>

                                Market Data

                            </span>



                            <strong>

                                Connected

                            </strong>



                        </div>


                    </div>





                </div>


                {/*<div className="active-installations-section">


                    <h3>

                    Active MT5 Installations

                    </h3>



                    <InstallationTable


                    installations={this.props.installations}


                    onDetails={this.props.onDetails}


                    onDeactivate={this.props.onDeactivate}


                    />


                </div>*/}







                <div className="engine-status-box">



                    <FaSyncAlt />



                    <div>



                        <strong>

                            Last AI Synchronization

                        </strong>



                        <p>

                            Engine connected and processing market intelligence

                        </p>



                    </div>




                </div>






            </div>



        );



    }



}



export default TradingIntelligenceCard;